import partnershipModalHtml from "./partnership-modal.html";
import PartnershipFormHandler from "./partnership-form-handler";

export default class PartnershipModal{

    constructor(preLoaderHandler, toastHandler, errorHandler) {
        $("body").append(partnershipModalHtml);
        this.modal = $("#partnershipModal");
        this.openButton = $(".partnership-button");
        this.partnershipFormHandler = new PartnershipFormHandler(preLoaderHandler, toastHandler, errorHandler, this.modal);
    }

    init(){
        const self = this;
        self.partnershipFormHandler.init();
        self.openButton.on("click", function (){
            self.show();
        });
    }

    show(){
        const self = this;
        self.modal.modal("show");
    }

    hide(){
        const self = this;
        self.modal.modal("hide");
    }
}